module.exports = __webpack_public_path__ + "img/microsoft_account_selection_screen.4f14f382.png";